(function()  {
    async function initMaps() {
    const { Map, InfoWindow } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    const maps = document.querySelectorAll("[data-gmap]");

    if(maps && maps.length) {
        maps.forEach((map) => {
                const customIcon = document.createElement("img");
                let pinUrl = map.getAttribute("data-gmap-pin");
                let lat = map.getAttribute("data-gmap-lat");
                let lng = map.getAttribute("data-gmap-lng");
                let place = map.getAttribute("data-gmap-place");
                const info = map.nextElementSibling.innerHTML;
                let infoWindow = null;

                if(lat) lat = parseFloat(lat);
                if(lng) lng = parseFloat(lng);

                if(pinUrl){
                   pinUrl = `https:${pinUrl.split('?')[0]}`;
                    customIcon.src = pinUrl;
                    customIcon.style.width = "40px";
                    customIcon.style.height = "40px";
                }


                if (info) {
                    infoWindow = new InfoWindow({
                        content: info,
                    });
                }


                const locationMap = new Map(map, {
                        center: { lat: lat, lng: lng },
                        zoom: 13,
                        mapId: '2977727cffbb86f486feb51c',
                        disableDefaultUI: true,
                });

                const marker = new AdvancedMarkerElement({
                    position: { lat: lat, lng: lng },
                    map: locationMap,
                    content: customIcon
                });

                marker.addListener('gmp-click', () => {
                    infoWindow.open({anchor: marker, map: map});
                });
            });
        }
    }

    if (window.googleMapConsent) {
        window.googleMapConsent.onAccept(initMaps);
    } else {
        initMaps();
    }

class OpeningHours extends HTMLElement {
    constructor() {
        super();
    }

    isNowInWeeklyTimeFrame (day, start, end) {
        const dayMap = {
            "sunday": 0, "monday": 1, "tuesday": 2, "wednesday": 3,
            "thursday": 4, "friday": 5, "saturday": 6
        };

        const now = new Date();
        const nowDay = now.getDay();
        const nowMinutes = now.getHours() * 60 + now.getMinutes();
        const targetDay = dayMap[day.toLowerCase()];

        if (typeof targetDay === "undefined") throw new Error("Invalid day: " + day);

        // Only compare times if today is the day
        if (nowDay !== targetDay) return false;

        const [startH, startM] = start.split(':').map(Number);
        const [endH, endM] = end.split(':').map(Number);
        const startMinutes = startH * 60 + startM;
        const endMinutes = endH * 60 + endM;
        return nowMinutes >= startMinutes && nowMinutes <= endMinutes;
    }

    updateCurrentOpeningTime() {
        this.timeMap.map(function(time){
            const nowActive = time.times.filter(function(t, i) {
                const isOpen = this.isNowInWeeklyTimeFrame(time.day, t.opens, t.closes);

                if(isOpen) {
                    this.currentlyOpenedDay = time.day;
                    this.currentlyOpenedTimeIndex = i;
                }

                return isOpen;
            }.bind(this));

            if(nowActive && nowActive.length) {
                // CLEAN OLD ACTIVE VALUES
                this.querySelectorAll('[data-opening-day]').forEach((day) => {
                    day.removeAttribute('data-opening-day-active');

                    day.querySelectorAll('[data-opening-time]').forEach((time) => {
                        time.removeAttribute('data-opening-time-active');
                    });
                });

                // UPDATE NEW ACTIVE VALUES
                const activeDay = this.querySelector('[data-opening-day="' + this.currentlyOpenedDay + '"]');

                if(activeDay) {

                }

                activeDay.setAttribute('data-opening-day-active', 'true');
                const currentDayTimes = activeDay.querySelectorAll('[data-opening-time]');
                currentDayTimes[this.currentlyOpenedTimeIndex].setAttribute('data-opening-time-active', 'true');
            }
        }.bind(this));
    }

    connectedCallback() {
        this.timeElements = this.querySelectorAll('.boutique-location__oh-item');
        this.timeMap = [];

        if(this.timeElements && this.timeElements.length) {
            this.timeElements.forEach((timeElement) => {
                const day = timeElement.getAttribute('data-opening-day');
                const times = timeElement.querySelectorAll('[data-opening-time]');
                const currentTimes = [];

                if(times && times.length) {
                    times.forEach((time) => {
                        const openingTime = time.getAttribute('data-opening-timestamp');
                        const closingTime = time.getAttribute('data-closing-timestamp');

                        currentTimes.push({
                            'opens' : openingTime,
                            'closes' : closingTime
                        });
                    });
                }

                this.timeMap.push({
                    el: timeElement,
                    day: day.toLowerCase(),
                    times: currentTimes
                });
            });
        }

        this.updateCurrentOpeningTime();

        setInterval(function() {
            this.updateCurrentOpeningTime();
        }.bind(this), 1000 * 60);
    }
}

customElements.define('opening-hours', OpeningHours);

})();
let map;


